import { useEffect, useState } from "react";

export function useIsMobile(width: number = 768) {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    // Function to check if the viewport is mobile
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < width);
    };

    // Run on mount
    checkIsMobile();

    // Add resize event listener
    window.addEventListener("resize", checkIsMobile);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", checkIsMobile);
  }, [width]);

  return { isMobile };
}
